module.exports = __webpack_public_path__ + "img/specimen.92a6faaa.png";